import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import connect from '../store/connect';
import { setViewstate } from '../actions/actionCreators';
import { color, size } from '../styles/helpers/variables';
import { fontFamilyBody } from '../styles/helpers/mixins';
import RenderPrice from '../components/RenderPrice';

const probableHeightOfStickyBuy = 106;

class StickyButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholderHeight: probableHeightOfStickyBuy,
      isFixed: true
    };
    this.checkIfFixed = this.checkIfFixed.bind(this);
    this.setPlaceholderHeight = this.setPlaceholderHeight.bind(this);
  }

  componentDidMount() {
    this.setPlaceholderHeight();
    this.checkIfFixed();
    window.addEventListener('resize', this.setPlaceholderHeight);
    window.addEventListener('scroll', this.checkIfFixed);
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.checkIfFixed()); // eslint-disable-line no-undef
      this.resizeObserver.observe(document.body);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.viewstate.get('brokeDesign') !== this.props.viewstate.get('brokeDesign')) {
      setTimeout(() => {
        this.setPlaceholderHeight();
        this.checkIfFixed();
      }, 0);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setPlaceholderHeight);
    window.removeEventListener('scroll', this.checkIfFixed);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  setPlaceholderHeight() {
    this.setState({
      placeholderHeight: this.stickyBuyRef ? this.stickyBuyRef.offsetHeight : probableHeightOfStickyBuy
    });
  }

  checkIfFixed() {
    this.setState({
      isFixed: this.placeholderRef && this.placeholderRef.getBoundingClientRect().bottom >= window.innerHeight
    });
  }

  render() {
    const { placeholderHeight, isFixed } = this.state;
    const { active, disabled, selectedVariant, currentOptionsPrice, quantitySelector } = this.props;

    return (
      <ProductPageStickyBuyPlaceholder
        style={{ height: placeholderHeight }}
        innerRef={element => {
          this.placeholderRef = element;
        }}
      >
        <ProductPageStickyBuy
          fixed={isFixed}
          innerRef={element => {
            this.stickyBuyRef = element;
          }}
        >
          <ProductPageStickyBuyContent>
            <ProductPageStickyBuyUSPList>
              <ProductPageStickyBuyUSPListItem>
                <ProductPageStickyBuyUSPListItemItem>Frakt från 99 – 790 kr</ProductPageStickyBuyUSPListItemItem>
                {selectedVariant.get('deliveryInformation') && (
                  <ProductPageStickyBuyUSPListItemItem>
                    {`Leveranstid: ${selectedVariant.get('deliveryInformation')}`}
                  </ProductPageStickyBuyUSPListItemItem>
                )}
              </ProductPageStickyBuyUSPListItem>
              <ProductPageStickyBuyUSPListItem>
                <ProductPageStickyBuyUSPListItemItem>14 Dagar returrätt</ProductPageStickyBuyUSPListItemItem>
                <ProductPageStickyBuyUSPListItemItem>3 Års reklamationsrätt</ProductPageStickyBuyUSPListItemItem>
              </ProductPageStickyBuyUSPListItem>
            </ProductPageStickyBuyUSPList>
            <ProductPageStickyBuyPrice>
              <RenderPrice
                currentOptionsPrice={currentOptionsPrice}
                price={selectedVariant.get('price')}
                originalPrice={selectedVariant.get('originalPrice')}
                fontWeight="700"
              />
            </ProductPageStickyBuyPrice>
          </ProductPageStickyBuyContent>
          <ProductPageStickyBuyButtonContent>
            {quantitySelector}
            <ProductPageStickyBuyButton active={active} disabled={disabled} onClick={this.props.onClick}>
              Lägg i varukorg
            </ProductPageStickyBuyButton>
          </ProductPageStickyBuyButtonContent>
        </ProductPageStickyBuy>
      </ProductPageStickyBuyPlaceholder>
    );
  }
}

StickyButton.defaultProps = {
  viewstate: Map(),
  active: false,
  disabled: false,
  selectedVariant: Map(),
  currentOptionsPrice: null,
  quantitySelector: null
};

StickyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  selectedVariant: PropTypes.instanceOf(Map),
  currentOptionsPrice: PropTypes.number,
  quantitySelector: PropTypes.element
};

export default connect(StickyButton, { setViewstate }, store => ({
  viewstate: store.viewstate
}));

const ProductPageStickyBuyPlaceholder = styled.div`
  height: 106px;
  margin: -40px 0 7px;
`;

const ProductPageStickyBuy = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  padding: 10px calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.xLarge} - ${size.small})))) 21px
    calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.xLarge} - ${size.small}))));
  background-color: #f2f2f2;
  z-index: 100;
  // transition: box-shadow 0.125s ease;
  ${props =>
    props.fixed &&
    css`
      position: fixed;
      bottom: 0;
      box-shadow: 0 0 10px rgb(000, 000, 000, 25%);
    `};
`;

const ProductPageStickyBuyContent = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 0 0 10px;
`;

const ProductPageStickyBuyPrice = styled.div`
  flex: 0 0 auto;
  > div {
    margin: 0;
    line-height: 1;
    > p {
      display: block;
      margin: 0;
      font-size: 14px;
      line-height: 1;
      + p {
        margin: 2.5px 0 0;
        font-size: 12px;
      }
    }
  }
`;

const ProductPageStickyBuyUSPList = styled.ul`
  list-style: none;
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  padding: 0 10px 0 0;
  color: ${color.black};
  font-size: 9px;
  font-weight: 600;
  line-height: 1.25;
`;
const ProductPageStickyBuyUSPListItem = styled.li`
  margin: 0 0 2.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  &:last-child {
    margin: 0;
  }
`;
const ProductPageStickyBuyUSPListItemItem = styled.span`
  margin: 0 10px 0 0;
  &:last-child {
    margin: 0;
  }
  &:before {
    content: '';
    display: inline-block;
    height: 3px;
    width: 6px;
    margin: -3px 5px 0 0;
    border-left: 1px solid ${color.primary};
    border-bottom: 1px solid ${color.primary};
    transform: rotate(-45deg);
    vertical-align: middle;
  }
`;

const ProductPageStickyBuyButtonContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media screen and (min-width: 320px) {
    flex-wrap: nowrap;
  }
`;

const ProductPageStickyBuyButton = styled.button`
  display: block;
  position: relative;
  width: 100%;
  padding: 15px 20px;
  border: 1px solid ${color.success};
  outline: none;
  background-color: ${color.success};
  color: ${color.white};
  ${fontFamilyBody};
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.125em;
  text-transform: uppercase;
  text-align: center;
  overflow: hidden;
  cursor: pointer;
  transition: opacity 0.125s ease, border-color 0.125s ease;
  &:hover {
    opacity: 0.875;
  }
  &:focus {
    border-color: ${color.black};
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${color.success};
    background-image: url('/images/icons/checkmark.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px;
    opacity: 0;
    transform: translateY(-100%);
    transition: opacity 0.5s ease-in-out, transform 0.25s ease-in-out;
  }
  ${props =>
    props.active &&
    css`
      border-color: ${color.success};
      opacity: 1;
      cursor: default;
      &:after {
        opacity: 1;
        transform: translateY(0);
      }
    `};
`;



// WEBPACK FOOTER //
// ./src/components/StickyButton.js